import { SvgIcon, SvgIconProps } from "@sol/uikit/core/icons/SvgIcon";

export const UserProfile01 = (props: SvgIconProps) => {
    return (
        <SvgIcon {...props} width="24" height="24" viewBox="0 0 24 24">
            <g id="user-profile-01">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12.0002 3.3999C10.5642 3.3999 9.40016 4.56396 9.40016 5.9999C9.40016 7.43584 10.5642 8.5999 12.0002 8.5999C13.4361 8.5999 14.6002 7.43584 14.6002 5.9999C14.6002 4.56396 13.4361 3.3999 12.0002 3.3999ZM7.40016 5.9999C7.40016 3.45939 9.45965 1.3999 12.0002 1.3999C14.5407 1.3999 16.6002 3.45939 16.6002 5.9999C16.6002 8.54041 14.5407 10.5999 12.0002 10.5999C9.45965 10.5999 7.40016 8.54041 7.40016 5.9999ZM2.60056 17.9994C2.60085 15.4591 4.66026 13.3999 7.20056 13.3999H16.7998C19.3405 13.3999 21.4001 15.4596 21.3998 18.0003L21.3995 21.6C21.3995 22.1523 20.9517 22.5999 20.3994 22.5999C19.8471 22.5998 19.3995 22.1521 19.3995 21.5998L19.3998 18.0001C19.4 16.5641 18.2359 15.3999 16.7998 15.3999H7.20056C5.76474 15.3999 4.60072 16.5638 4.60056 17.9996L4.60016 21.6C4.6001 22.1523 4.15233 22.6 3.60005 22.5999C3.04776 22.5998 2.6001 22.1521 2.60016 21.5998L2.60056 17.9994Z"
                    className="fill-current"
                />
            </g>
        </SvgIcon>
    );
};
